if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;


        // Get the current date
        let currentDate = moment().tz("America/New_York");
        
        // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        let currentDay = currentDate.day();
        

        let currentHour = currentDate.hour();
        const isAfter8AM = currentHour >= 8;
        const isBefore9PM = currentHour < 21;

        

        // console.log(currentDay)
        // console.log(currentHour)


        let pickNextWeeksFoodContainer = document.querySelector(
          ".pick-next-weeks-food-container"
        );
        
        let isCustomerLoggedIn = false;

        if (pickNextWeeksFoodContainer) {
          isCustomerLoggedIn = (pickNextWeeksFoodContainer.dataset.customerLoggedIn === 'true');
        } 

        let isCustomerAMember = false;
        
        if (pickNextWeeksFoodContainer) {
          isCustomerAMember = (pickNextWeeksFoodContainer.dataset.customerIsMember === 'true');
        } 

        let isCustomerInDeliverableZip = false;
        
        if (pickNextWeeksFoodContainer) {
          isCustomerInDeliverableZip = (pickNextWeeksFoodContainer.dataset.customerIsInDeliverableZip === 'true');
        } 

        if (!isCustomerLoggedIn) {
          Swal.fire({
            title: 'Login or Create an Account',
            text: ``,
            confirmButtonText: 'Login',
            cancelButtonText: 'Create an Account',
            showCancelButton: true,
            allowOutsideClick: true,
            showCloseButton: true,
            width: '43em',
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {


              if (localStorage.getItem('LoginButtonClickedOnMenuPagePopup') === null || localStorage.getItem('LoginButtonClickedOnMenuPagePopup') === 'false') {
                // Key 'LoginButtonClickedOnMenuPagePopup' does not exist in localStorage, so we can set it to true
                localStorage.setItem('LoginButtonClickedOnMenuPagePopup', true);
              } else {
                // Key 'LoginButtonClickedOnMenuPagePopup' already exists in localStorage
                // You can choose to do something else here if needed
                console.log('Key "LoginButtonClickedOnMenuPagePopup" already exists in localStorage.');
}
              
              window.location = "/account/login";

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );

              
            } else if (result.isDismissed && (result.dismiss === Swal.DismissReason.cancel))  {
                           
              window.location = "/account/register";

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
              
            }
            
            else  {
                           
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
            }
          });
        }  else if (isCustomerLoggedIn && !isCustomerInDeliverableZip) {
          Swal.fire({
            title: "We Cannot Deliver to Your Address",
            text: `If you think this may be an error, or if you haven't entered your delivery address yet, please do so now.`,
            confirmButtonText: 'Update My Delivery Address',
            allowOutsideClick: true,
            showCloseButton: true,
            width: '43em',
          }).then((result) => {

                if (result.isConfirmed) {
                window.location = "/account/addresses";     

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
                            
              } else {
                           
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
                          }
 
          });
        }        
        
        else if (isCustomerLoggedIn && canOrder && isCustomerInDeliverableZip) {





        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });


          


        } else if (isCustomerLoggedIn && (!isCustomerAMember && !canOrder) && isCustomerInDeliverableZip) {
          Swal.fire({
            title: "Orders can only be placed Thursday through Sunday",
            text: 'You can still purchase a membership beforehand!',
            confirmButtonText: 'Purchase Biggers Box Membership',
            showCancelButton: true,
            reverseButtons: true,
            allowOutsideClick: true,
            showCloseButton: true,
            width: '43em',
          }).then((result) => {

                if (result.isConfirmed) {
                window.location = "/cart/clear?return_to=/cart/add?items[][id]=43000392155305%26items[][quantity]=1%26items[][selling_plan]=1174864041%26return_to=/checkout";     

              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
                            
              } else {
                           
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
                          }
 
          });
        } else if (isCustomerLoggedIn && (isCustomerAMember && !canOrder) && isCustomerInDeliverableZip) {
          Swal.fire({
            title: "Orders can only be placed Thursday through Sunday",
            text: ``,
            allowOutsideClick: true,
            showCloseButton: true,
            width: '43em',
          }).then((result) => {

     
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden"
              );
                   
 
          });
        }

        













        

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
